const CaseFilesPostPoned = {
    RequestPostPone: 0,
    AcceptedPostPone: 1
}

export default CaseFilesPostPoned